/**
 * Query keys for the campaign table shown on entity and contact detail pages.
 *
 * The view is scoped to an entity or to a contact, never both, matching the
 * concatenated key this replaces.
 */
export const campaignViewKeys = {
  all: ["campaigns-view"],
  lists: () => [...campaignViewKeys.all, "list"],
  list: ({ entityId = null, contactId = null } = {}) => [
    ...campaignViewKeys.lists(),
    { entityId, contactId },
  ],
};
